import { useMutation } from "@tanstack/react-query";

import { verifyCode } from "~/providers/api/verificationCode";

export const useVerifyCode = () => {
  return useMutation({
    mutationFn: verifyCode,
  });
};
